export const LANGS = ['EN', 'ZH_CN', 'ZH_HK', 'ZH_TW']
export const LANGS_WITHOUT_TW = ['EN', 'ZH_CN', 'ZH_HK']
export const LANG = {
  EN: '',
  ZH_CN: '',
  ZH_HK: '',
  ZH_TW: '',
}
